import { useSuspenseInfiniteQuery } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { FetchExcludeList } from '..';

const LIMIT = 20;

export const useExcludeList = () => {
  const { workspaceId } = useWorkspaceId();
  const queryKeys = useQueryKeys();
  return useSuspenseInfiniteQuery({
    queryKey: queryKeys.excludeList.all(),
    queryFn: async ({ signal, pageParam }) => {
      const res = await FetchExcludeList(
        {
          workspace_id: workspaceId,
          cursor: pageParam,
          limit: LIMIT,
        },
        signal,
      );
      return {
        creators: res.creators,
        next_cursor: res.next_cursor,
      };
    },
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => {
      return lastPage.next_cursor;
    },
  });
};
